import $ from "jquery";
import { tns } from "tiny-slider";
import "./imports/dsgvo-video-embed.min";

window.$ = $;
window.jQuery = $;

import("shariff").then(({ default: Shariff }) => {
  document.querySelectorAll(".shariff").forEach((element) => {
    new Shariff(element);
  });
});

let menuBtn = $("#toggle-menu");
let labelExpanded = menuBtn.data("label-aria-expanded-true");
let labelCollapsed = menuBtn.data("label-aria-expanded-false");
let previousActiveElement;
let focusableElements;
let firstFocusable;
let lastFocusable;

function trapFocus(modal) {
  focusableElements = modal.find(
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
  );

  firstFocusable = focusableElements.first();
  lastFocusable = focusableElements.last();

  firstFocusable.trigger("focus");

  $(document).on("keydown.focusTrap", function (event) {
    // ESC closes
    if (event.key === "Escape") {
      closeSearchbar();
    }

    // TAB cycle
    if (event.key === "Tab") {
      if (event.shiftKey) {
        // backward
        if (document.activeElement === firstFocusable[0]) {
          event.preventDefault();
          lastFocusable.trigger("focus");
        }
      } else {
        // forward
        if (document.activeElement === lastFocusable[0]) {
          event.preventDefault();
          firstFocusable.trigger("focus");
        }
      }
    }
  });
}

function releaseFocus() {
  $(document).off("keydown.focusTrap");
  if (previousActiveElement) previousActiveElement.focus();
}

function openMenu() {
  menuBtn.attr("aria-expanded", true);
  menuBtn.attr("aria-label", labelExpanded);
  $("body").addClass("menu-open");

  $(document).on("keydown", function (event) {
    if (event.key === "Escape") {
      closeMenu();
    }
  });
}

function closeMenu() {
  menuBtn.attr("aria-expanded", false);
  menuBtn.attr("aria-label", labelCollapsed);
  $("body").removeClass("menu-open");
}

function openSearchbar() {
  previousActiveElement = document.activeElement;

  $("#toggle-search").attr("aria-expanded", true);
  $("#close-search").attr("aria-expanded", true);
  $("#site-header__search-form").addClass("is-open");

  trapFocus($("#site-header__search-form"));
}

function closeSearchbar() {
  $("#toggle-search").attr("aria-expanded", false);
  $("#close-search").attr("aria-expanded", false);
  $("#site-header__search-form").removeClass("is-open");

  releaseFocus();
}

function activateLinkFocus() {
  $(".tns-item a").attr("tabindex", "-1");
  $(".tns-slide-active a:not(:has(img))").attr("tabindex", "0");
}

/// Set iFrame titles
$(function () {
  function setTitles(root) {
    $(root)
      .find(".iframe[data-iframe-title] iframe")
      .each(function () {
        const $iframe = $(this);
        const $container = $iframe.closest(".iframe[data-iframe-title]");
        const title = $.trim($container.attr("data-iframe-title"));

        if (title) {
          // Always replace existing title
          $iframe.attr("title", title);
        }
      });
  }

  // Initial run
  setTitles(document);

  // Watch for dynamically added content
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        setTitles(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

$(document).ready(function () {
  // MENU TOGGLE
  menuBtn.on("click", function () {
    if (menuBtn.attr("aria-expanded") == "true") {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // Dropdown toggle
  $(".site-header__menu button").on("click", function () {
    let btn = $(this);
    let dropdown = $(this).next("ul");

    if (btn.attr("aria-expanded") == "true") {
      btn.attr("aria-expanded", false);
      dropdown.removeClass("expanded");
    } else {
      btn.attr("aria-expanded", true);
      dropdown.addClass("expanded");
    }
  });

  // Search toggle
  $("#toggle-search").on("click", function () {
    openSearchbar();
  });

  $("#close-search").on("click", function () {
    closeSearchbar();
  });

  // Language toggle
  $("#toggle-languages").on("click", function () {
    let btn = $(this);
    let parent = $("#site-header__languages");

    if (btn.attr("aria-expanded") == "true") {
      btn.attr("aria-expanded", false);
      parent.removeClass("active");
    } else {
      btn.attr("aria-expanded", true);
      parent.addClass("active");
    }
  });

  // Flip boxes
  if (window.matchMedia("(pointer: coarse)").matches) {
    $("a.flip-box").each(function () {
      $(this).on("click", function (event) {
        event.preventDefault();
      });

      var linkEl = $(this).find(".flip-box__target-touch");
      var target = $(this).attr("href");

      linkEl.show();

      linkEl.on("click", function (event) {
        location.replace(target);
      });
    });
  }
  $(".flip-box__btn").on("click", function (event) {
    var box = $(this).parent().parent();
    var textFlipped = $(this).data("text-flipped");
    var textDefault = $(this).data("text-default");

    if (box.hasClass("flipped")) {
      $(this).text(textDefault);
      box.removeClass("flipped");
    } else {
      $(this).text(textFlipped);
      box.addClass("flipped");
    }
  });

  // Play Video Button
  $(".video-play-btn").on("click", function () {
    $("video").trigger("pause");
    $(this).parent().hide();
    $(this).parent().parent().find("video").trigger("play");
  });

  $(".hero-img__vid-btn-play").click(function () {
    var video = $(this).prev("video")[0];

    if (video.paused) {
      video.play();
      $(this).addClass("playing").removeClass("paused").text("Video pausieren");
    } else {
      video.pause();
      $(this).addClass("paused").removeClass("playing").text("Video abspielen");
    }
  });

  $(".hero-img__vid-btn-tracks").click(function () {
    var videoId = this.getAttribute("data-video");
    var videoElement = document.getElementById(videoId);
    var textTracks = videoElement.textTracks; // one for each track element
    var textTrack = textTracks[0]; // corresponds to the first track element

    if (textTrack.mode === "showing") {
      textTrack.mode = "hidden";
      $(this).removeClass("active").attr("aria-label", "Untertitel einblenden");
    } else {
      textTrack.mode = "showing";
      $(this).addClass("active").attr("aria-label", "Untertitel ausblenden");
    }
  });

  // Image Slider
  var imageSlider = $(".image-slider__items");
  var imageSliderItemCount = imageSlider.data("item-count");

  if (imageSliderItemCount > 1) {
    imageSliderControls = true;
    //imageSliderNav = true;
  }

  imageSlider.each(function () {
    var slider = tns({
      container: this,
      speed: 750,
      items: 1,
      controls: true,
      nav: false,
      gutter: 16,
      responsive: {
        1024: {
          items: imageSliderItemCount,
        },
      },
      onInit: activateLinkFocus,
    });

    slider.events.on("indexChanged", activateLinkFocus);
  });

  // Project Slider
  var pageSlider = $(".page-slider__items");
  pageSlider.each(function () {
    var desktopItems = parseInt($(this).data("desktop-items"), 10) || 2;
    var slider = tns({
      container: this,
      loop: false,
      speed: 750,
      items: 1,
      controls: true,
      nav: false,
      gutter: 16,
      responsive: {
        768: {
          items: 2,
        },
        1200: {
          items: desktopItems,
        },
      },
      onInit: activateLinkFocus,
    });

    slider.events.on("indexChanged", activateLinkFocus);
  });

  // Team Slider
  var teamSlider = $(".team-slider__items");
  teamSlider.each(function () {
    var slider = tns({
      container: this,
      speed: 750,
      items: 1,
      controls: true,
      nav: false,
      onInit: activateLinkFocus,
    });

    slider.events.on("indexChanged", activateLinkFocus);
  });

  // Logo carousel
  $(".logo-carousel").each(function () {
    const $carousel = $(this);
    const $toggle = $carousel.find(".logo-carousel__toggle");

    $toggle.on("click", function () {
      $carousel.toggleClass("is-paused");

      const paused = $carousel.hasClass("is-paused");
      $toggle.attr("data-action", paused ? "start" : "stop");
      $toggle.attr(
        "aria-label",
        paused ? "Logo Karussell starten" : "Logo Karussell stoppen",
      );
    });
  });
  // var logoCarousel = $(".logo-carousel__items");
  // logoCarousel.each(function () {
  //   tns({
  //     container: this,
  //     speed: 400,
  //     items: 2,
  //     edgePadding: 0,
  //     controls: true,
  //     nav: false,
  //     gutter: 50,
  //     mouseDrag: true,
  //     autoplay: true,
  //     autoplayPosition: "bottom",
  //     autoplayText: ["starten", "anhalten"],
  //     autoplayTimeout: 3000,
  //     disable: true,
  //     responsive: {
  //       // 600: {
  //       //   items: 4,
  //       // },
  //       800: {
  //         disable: false,
  //         items: 5,
  //       },
  //       1200: {
  //         gutter: 75,
  //       },
  //       1600: {
  //         items: 6,
  //       },
  //     },
  //   });
  // });

  // ACCORDION
  $(".accordion-item__btn").on("click", function () {
    var $button = $(this);
    var $item = $button.closest(".accordion-item");
    var $panel = $item.find(".accordion-item__panel").first();
    var isOpen = $button.attr("aria-expanded") === "true";

    // Close all
    $(".accordion-item").removeClass("open");
    $(".accordion-item__btn").attr("aria-expanded", "false");
    $(".accordion-item__panel").css("max-height", "0px");

    // Open clicked item if it was closed
    if (!isOpen) {
      $button.attr("aria-expanded", "true");
      $item.addClass("open");
      $panel.css("max-height", $panel.prop("scrollHeight") + "px");
    }
  });

  /// UMFRAGE
  $('#questions__form input[type="radio"]').on("change", function () {
    const allFilled = $('#questions__form input[type="radio"]')
      .toArray()
      .every((radio) => $(`input[name="${radio.name}"]:checked`).length > 0);
    if (allFilled) {
      $("#questions__cta").show();
    } else {
      $("#questions__cta").hide();
    }
  });

  $('#questions__form input[type="radio"]').trigger("change");
});

//// STATS Counter
document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".stats-counter__item-value");

  const animateCounter = function (el) {
    const raw = el.dataset.value;

    // Convert decimal comma to dot for math
    const numericString = raw.replace(",", ".");
    const target = parseFloat(numericString);

    // Get number of decimal places based on input
    const decimals = (raw.split(",")[1] || "").length;

    $({ countNum: 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: "swing",
        step: function () {
          el.textContent = this.countNum.toFixed(decimals).replace(".", ",");
        },
        complete: function () {
          el.textContent = target.toFixed(decimals).replace(".", ",");
        },
      },
    );
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains("counted")
        ) {
          entry.target.classList.add("counted");
          animateCounter(entry.target);
        }
      });
    },
    { threshold: 0.6 },
  );

  counters.forEach((counter) => observer.observe(counter));
});

//// FILTER BUTTONS
$(document).ready(function () {
  $(".filter-toggle").on("click", function () {
    const $filters = $("#filter-buttons");
    const isOpen = $filters.toggleClass("is-open").hasClass("is-open");

    $(this).attr("aria-expanded", isOpen);
    //$(this).text(isOpen ? "Filter ausblenden" : "Filter anzeigen");
  });
});

////// STICKY WIDGET

jQuery(function ($) {
  const $widget = $("#sticky-widget");
  const $panel = $("#sticky-widget-panel");
  const $toggle = $widget.find(".sticky-widget__toggle");
  const $closeBtn = $widget.find(".sticky-widget__close");
  const $firstInput = $widget.find("#sticky-name");

  const $openText = $widget.find(".sticky-widget__toggle-text-open");
  const $closeText = $widget.find(".sticky-widget__toggle-text-close");

  const $iconClosed = $toggle.find("img").eq(0);
  const $iconOpen = $toggle.find("img").eq(1);
  const $fallbackOpen = $toggle.find("span").filter(function () {
    return $(this).text().trim() === "Kontakt-Popup öffnen";
  });
  const $fallbackClose = $toggle.find("span").filter(function () {
    return $(this).text().trim() === "Kontakt-Popup schließen";
  });

  const openingDelay = parseFloat($widget.attr("data-opening-delay"));
  const storageKey = "stickyWidgetAutoOpened";
  let autoOpenTimer = null;
  let hasAutoOpened = false;

  function setOpenState() {
    $panel.removeClass("is-hidden").attr("aria-hidden", "false");

    setTimeout(function () {
      $panel.addClass("is-open");
    }, 10);

    $toggle.attr({
      "aria-expanded": "true",
      "aria-label": "Kontaktfenster schließen",
    });

    $openText.addClass("is-hidden");
    $closeText.removeClass("is-hidden");

    $iconClosed.addClass("is-hidden");
    $iconOpen.removeClass("is-hidden");
    $fallbackOpen.addClass("is-hidden");
    $fallbackClose.removeClass("is-hidden");
  }

  function setClosedState() {
    $panel.removeClass("is-open").attr("aria-hidden", "true");

    $toggle.attr({
      "aria-expanded": "false",
      "aria-label": "Kontaktfenster öffnen",
    });

    $openText.removeClass("is-hidden");
    $closeText.addClass("is-hidden");

    $iconClosed.removeClass("is-hidden");
    $iconOpen.addClass("is-hidden");
    $fallbackOpen.removeClass("is-hidden");
    $fallbackClose.addClass("is-hidden");
  }

  function openWidget(withFocus = true) {
    clearTimeout(autoOpenTimer);
    setOpenState();

    if (withFocus && !isMobile && $firstInput.length) {
      setTimeout(function () {
        $firstInput.trigger("focus");
      }, 120);
    }
  }

  function closeWidget() {
    clearTimeout(autoOpenTimer);
    setClosedState();
  }

  $panel.on("transitionend", function (e) {
    if (e.originalEvent.propertyName !== "opacity") return;

    if (!$panel.hasClass("is-open")) {
      $panel.addClass("is-hidden");
    }
  });

  $toggle.on("click", function () {
    const expanded = $toggle.attr("aria-expanded") === "true";
    expanded ? closeWidget() : openWidget(true);
  });

  $closeBtn.on("click", function () {
    closeWidget();
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && $toggle.attr("aria-expanded") === "true") {
      e.preventDefault();
      closeWidget();
    }
  });

  const isMobile = window.innerWidth < 1024;

  if ($widget.attr("data-open-on-load") === "true") {
    setOpenState();
  } else if (!localStorage.getItem(storageKey)) {
    if (isMobile) {
      // 📱 Scroll trigger (60%)
      $(window).on("scroll", function () {
        if (hasAutoOpened) return;

        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        const documentHeight = $(document).height();

        const scrollPercent = (scrollTop + windowHeight) / documentHeight;

        if (scrollPercent >= 0.7) {
          if ($toggle.attr("aria-expanded") !== "true") {
            openWidget(false);
            localStorage.setItem(storageKey, "true");
            hasAutoOpened = true;
          }
        }
      });
    } else if (!isNaN(openingDelay) && openingDelay > 0) {
      // 💻 Original delay behavior
      autoOpenTimer = setTimeout(function () {
        if ($toggle.attr("aria-expanded") !== "true") {
          openWidget(false);
          localStorage.setItem(storageKey, "true");
        }
      }, openingDelay * 1000);
    }
  }
});
